/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiTabStyle = (theme: Theme): Components<Theme>["MuiTab"] => ({
  styleOverrides: {
    root: {
      typography: "button",
      color: theme.palette.text.primary,
      "&.Mui-selected": {
        color: theme.palette.text.primary,
      },
    },
  },
});
